import {
    GESTION_OPERATIVA_CHANGE_STATE_BEGIN,
    GESTION_OPERATIVA_CHANGE_STATE_SUCCESS,
    GESTION_OPERATIVA_CHANGE_STATE_ERROR
} from '../constants'
import { BFFAgent } from '../../../../common/BFFAgent'

export function changeState(id, sale_state, observation, cliente) {
    return async dispatch => {
        dispatch({
            type: GESTION_OPERATIVA_CHANGE_STATE_BEGIN
        })
        try {
            const res = await BFFAgent.Sales.changeState(id, sale_state, observation, cliente)
            dispatch({
                type: GESTION_OPERATIVA_CHANGE_STATE_SUCCESS,
                data: { sale_state: res.sale_state, observation }
            })
        } catch (error) {
            dispatch({
                type: GESTION_OPERATIVA_CHANGE_STATE_ERROR
            })
        }
    }
}